export default __webpack_public_path__ + "static/jakubg-1e02cc130d2d1863205156322dcc98ed.jpg";